export const Home_EN_Trans = {
  Headline: "Fiesta Catering",
  event: "Marketplace for Events",
  SubHeadline: "Book food trucks easily",
  note: `Are you planning an event or running your own food truck?`,
  note1: `Discover the right options now:`,
  note2: `Find the ideal caterer or become part of our platform as a partner.`,
  button: "Submit Inquiry?",
  customer:'Find a food truck',
  partner:'Become a partner',
  inquiry: {
    title: "Inquiry Form",
    submit: "Submit Inquiry",

  },
};

export const Home_DE_Trans = {
  Headline: "Fiesta Catering",
  event: "Marktplatz für Events",
  // SubHeadline: "Buche deinen Caterer",
  SubHeadline: "Foodtrucks einfach buchen",
  // note: `Du entscheidest! Willst du deinen Cateringservice selbst suchen und buchen oder benötigst du Unterstützung? Bei uns hast du die Wahl.`,
  note: `Du planst ein Event oder betreibst selbst einen Foodtruck?`,
  note1: "Entdecke jetzt die passenden Möglichkeiten:",
  note2: `Suche den idealen Caterer oder werde Teil unserer Plattform als Partner.`,
  button: "Anfrage stellen?",
  customer:'Foodtruck finden',
  partner:'Partner werden',
  inquiry: {
    title: "Anfrageformular",
    submit: "Anfrage stellen",
  },
};
